/**
 * UI Component Library
 * Centralized export for all reusable UI components
 */

// Button components
export { Button, default as ButtonDefault } from './Button';
export type { ButtonProps, ButtonVariant, ButtonSize } from './Button';

// Card components
export { Card, CardHeader, CardBody, CardFooter, default as CardDefault } from './Card';
export type { CardProps, CardVariant, CardHeaderProps, CardBodyProps, CardFooterProps } from './Card';

// Input components
export { Input, default as InputDefault } from './Input';
export type { InputProps, InputSize } from './Input';

// SearchInput component
export { SearchInput, default as SearchInputDefault } from './SearchInput';
export type { SearchInputProps } from './SearchInput';

// Badge components
export { Badge, StatusBadge, default as BadgeDefault } from './Badge';
export type { BadgeProps, BadgeVariant, BadgeSize } from './Badge';

// Avatar components
export { Avatar, AvatarGroup, default as AvatarDefault } from './Avatar';
export type { AvatarProps, AvatarSize, AvatarGroupProps } from './Avatar';

// Skeleton components
export {
  Skeleton,
  SkeletonText,
  SkeletonCard,
  SkeletonTable,
  SkeletonAvatar,
  SkeletonButton,
  SkeletonChart,
  SkeletonList,
  SkeletonStatCard,
  SkeletonDashboard,
  default as SkeletonDefault,
} from './Skeleton';
export type { SkeletonProps } from './Skeleton';

// Modal components
export { Modal, ConfirmModal, default as ModalDefault } from './Modal';
export type { ModalProps, ModalSize, ConfirmModalProps } from './Modal';

// Spinner components
export {
  Spinner,
  PageSpinner,
  OverlaySpinner,
  LoadingIndicator,
  default as SpinnerDefault,
} from './Spinner';
export type { SpinnerProps, SpinnerSize, SpinnerVariant, LoadingIndicatorProps } from './Spinner';

// StatCard component
export { StatCard, default as StatCardDefault } from './StatCard';
export type { StatCardProps, StatCardVariant, TrendDirection } from './StatCard';

// EmptyState components
export {
  EmptyState,
  NoDataEmpty,
  SearchEmpty,
  ErrorEmpty,
  default as EmptyStateDefault,
} from './EmptyState';
export type { EmptyStateProps, EmptyStateType } from './EmptyState';

// Tabs components
export { Tabs, TabPanel, default as TabsDefault } from './Tabs';
export type { TabsProps, TabItem, TabVariant, TabPanelProps } from './Tabs';

// Dropdown components
export { Dropdown, DropdownButton, default as DropdownDefault } from './Dropdown';
export type { DropdownProps, DropdownItem, DropdownButtonProps } from './Dropdown';

// Toast components
export { ToastProvider, useToast, default as ToastDefault } from './Toast';
export type { Toast, ToastType } from './Toast';

// CommandPalette component
export { CommandPalette, default as CommandPaletteDefault } from './CommandPalette';

// Breadcrumbs component
export { Breadcrumbs, default as BreadcrumbsDefault } from './Breadcrumbs';

// Sidebar component
export { default as Sidebar } from './Sidebar';
export type { NavItem, NavGroup } from './Sidebar';

// NotificationBell component
export { default as NotificationBell } from './NotificationBell';

// TourGuide component
export { TourGuide, default as TourGuideDefault } from './TourGuide';
export type { TourStep } from './TourGuide';

// PageHero component
export { default as PageHero } from './PageHero';

// Animations
export { default as PageTransition } from './animations/PageTransition';
export { default as StaggerContainer } from './animations/StaggerContainer';
export * from './animations/variants';

// Playful Toast components
export { PlayfulToastProvider, usePlayfulToast } from './PlayfulToastProvider';
export { PlayfulToast } from './PlayfulToast';
export { PlayfulToastSettings } from './PlayfulToastSettings';
export { Confetti } from './Confetti';
export type { MessageCategory, GradientTheme, PlayfulMessage } from './playfulMessages';

// HelpTooltip component
export { HelpTooltip, SectionHeaderWithHelp } from './HelpTooltip';
export type { } from './HelpTooltip';

// ResponsiveTable component
export { ResponsiveTable, createResponsiveTable } from './ResponsiveTable';
export type { } from './ResponsiveTable';
